<template>
    <template v-if="entry">
 <hr>
    <div 
        class="entry-title d-flex justify-content-center p-2 text-center">
            <div>
                <span class="text-success fs-3 fw-bold">{{day}}-</span>
                <span class="mx-1 fs-3">{{month}} -</span>
                <span class="mx-2 fs-4 fw-light">{{yearDay}}</span>
             
            </div>

            <div class="btn-flex">
                <button 
                    
                    class="btn btn-primary mx-2"
                    @click="$router.push({name:'list'})">
               
                    <i class="fas fa-arrow-circle-left"></i>
                </button>
             
                <button 
                    v-if="entry.id"
                    class="btn btn-danger mx-2"
                    @click="onDeleteEntry">
                    Borrar
                    <i class="fa fa-trash-alt"></i>
                </button>
                
            </div>
            
            

        </div>

        <hr>
        <div class="container mt-3 mb-5 d-flex justify-content-center">
    <div class="card px-1 py-4">
        <div class="card-body">
            <h3 class="card-title mb-3">Datos del cliente:</h3>
            <div class="d-flex flex-row between"> <div ><label class="radio mr-1 text-b"><span> <i class="fa fa-user"></i> Fecha Inicio </span>  </label></div> <div ><label class="radio text-b"><span> <i class="fa fa-plus-circle"></i> Fecha Fin</span>   </label> </div></div>
            <div class="d-flex flex-row "> <div class="cal-w"> <VueDatePicker v-model="entry.date" :enable-time-picker="false"></VueDatePicker></div>  <div class="cal-w"><VueDatePicker v-model="entry.dateFin" :enable-time-picker="false" ></VueDatePicker></div>  </div>
            
            <div class="row mb-4">
    <div class="col">
      <div class="form-outline">
        <label class="form-label text-b" for="form3Example1">Cliente</label>
        <input v-model="entry.text"  type="text"  class="form-control" />
     
      </div>
    </div>
    <div class="col">
      <div class="form-outline">
        <label class="form-label text-b" for="form3Example2">Monto</label>
        <input v-model="entry.monto" type="text" id="form3Example2" class="form-control" />
        
      </div>
    </div>
  </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label class="form-label text-b" for="form3Example2">Deuda</label>
                        
                        <!-- <label for="name">Name</label> --> <input  v-model="entry.deuda"  class="form-control" type="text" > </div>
                </div>
            </div>
            <div class="row margin-top">
                <div class="col-sm-12">
                    <div class="form-group">
                      <p>Días de Gym: {{ daysSinceLastDate }}</p>
        <p v-if="daysSinceLastDate === 5">solo 5 días</p>
        <p v-else-if="daysSinceLastDate === 0">termino mes</p>
                    </div>
                </div>
            </div>
           
            <div class=" d-flex flex-column text-center px-5 mt-3 mb-3"> <small class="agree-text">Wolf-Gym</small> <a href="https://michael-porcel.netlify.app" target="_blank" class="terms">By Mike</a> </div> 
        </div>
    </div>
</div>
     

     
         <img v-if="entry.picture && !localImage" :src="entry.picture" alt=""
        class="img-thumbnail"
        > 
         <img v-if="localImage" :src="localImage"  alt=""
        class="img-thumbnail"
        >
    </template>
    
    <Fab
    icon="fa-save"
    @on:click="saveEntry"
    />
    
</template>

<script>
import { defineAsyncComponent } from 'vue'
import {mapGetters, mapActions} from 'vuex'
import getDayMonthYear from '../helpers/getDayMonthYear'
import uploadImage from '../helpers/uploadImage'
import Swal from 'sweetalert2'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


export default {
props:{
    id:{
        type: String,
        required: true
    }

},
computed:{
    ...mapGetters('journal',['getEntryById']),
    day(){
        const { day } = getDayMonthYear(this.entry.date)
        return day
    },
        month(){
        const { month } = getDayMonthYear(this.entry.date)
        return month
    },
        yearDay(){
        const { yearDay } = getDayMonthYear(this.entry.date)
        return yearDay
    },
    fullDate(){
        const date = new Date(this.entry.date)
        return date
    },
    
    daysSinceLastDate() {
					const currentDate = new Date()
					const previousDate = new Date(this.entry.dateFin) 
					const timeDifference =  previousDate.getTime() - currentDate.getTime() 
					const daysDifference = Math.floor(timeDifference  / (1000 * 60 * 60 * 23))
                    const adjustedValue = daysDifference < 0 ? 0: daysDifference
                    if(isNaN(adjustedValue)){
                       return "0"
                    }
					return adjustedValue
				},
    
    
    
 },
components:{

    VueDatePicker,
Fab: defineAsyncComponent(()=> import('../components/Fab'))    
},

data(){
    return{
        entry:null,
        localImage:null,
        file: null,
        date:null,
        
        fiveDaysBefore: null
      
   
    }
},


methods:{
        ...mapActions('journal',['updateEntry', 'createEntry', 'deleteEntry']),
        loadEntry(){
            let entry;
            if(this.id === 'new'){
                entry = {
                    text:'',
                    date: new Date().getTime()
                
                    
                }
            }else{
                 entry = this.getEntryById(this.id)
            if(!entry) return this.$router.push({name:'no-entry'})
            }


    

       this.entry = entry
      
    },
    
    calculateFiveDaysBefore() {
      const millisecondsInADay = 24 * 60 * 60 * 1000; // Milisegundos en un día
      const fiveDaysBeforeMilliseconds = 5 * millisecondsInADay;

      const startTime = this.entry.dateFin.getTime();
      const fiveDaysBeforeTime = startTime - fiveDaysBeforeMilliseconds;

      this.fiveDaysBefore = new Date(fiveDaysBeforeTime);
    },


   async saveEntry(){

        new Swal({
            title:'Espere por favor',
            allowOutsideClick: false
        })
        Swal.showLoading()
       if( this.entry.text == "") return Swal.fire('Debes Ingresar un Cliente.','El campo cliente esta vacío','error' )  
       

       
    
        if( this.entry.id){
         await this.updateEntry(this.entry)
        } else{
            
         const id = await  this.createEntry(this.entry)
         this.$router.push({name:'list'})
         
        }

        
        
       Swal.fire('Guardado', 'Exito','success')
    },

    async onDeleteEntry(){
      const {isConfirmed} = await Swal.fire({
        title:'Estas seguro?',
        text:'No se Podra recuperar, una vez Borrado.',
        showDenyButton: true,
        confirmButtonText:'si, estoy seguro'
      })
      if( isConfirmed){
        new Swal({
            title:'Espere Porfavor',
            allowOutsideClick: false
        })
        Swal.showLoading()
         await this.deleteEntry(this.entry.id)
         this.$router.push({name:'list'})

         Swal.fire('Eliminado','','success')
      }

    },
    onSelectedFile(event){
        
        
        const file = event.target.files[0]
        if(!file){
            this.localImage = null
            this.file = null
            return
        }
        this.file = file
        const fr = new FileReader()
        fr.onload = ()=> this.localImage = fr.result
        fr.readAsDataURL(file)
    },
    onSelectedImage(){
        this.$refs.imageSelected.click()
    }
},

created(){
    this.loadEntry()
},

watch:{
    id(){
       this.loadEntry()
       
        
    }
}


}
</script>

<style lang="scss" scoped>
textarea{
    font-size: 20px;
    border: none;
    height: 100%;

    &:focus{
        outline: none;
    }
}
.between{
    justify-content: space-around;

}
.cal-w{
    width: 50% !important;
    margin: 2px !important;
}
img{
    width: 200px;
    position: fixed;
    bottom: 150px;
    right: 20px;
    box-shadow: 0px 5px 10px rgba($color: #000000, $alpha: 0.2);
}
.btn-flex{
    flex: none;
}
.margin-top{
    margin-top: 10px;
}

.text-b{
    font-weight: 600;
}
.card{width:500px;background-color:#fff;border-radius: 12px}

.form-control{margin-top: 10px;height: 48px;border: 2px solid #cacaca;border-radius: 10px}.form-control:focus{box-shadow: none;border: 2px solid #039BE5}.agree-text{font-size: 12px}.terms{font-size: 12px;text-decoration: none;color: #039BE5}.confirm-button{height: 50px;border-radius: 10px}
 


</style>